import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
    selector: 'tpc-shipping',
    templateUrl: './shipping.component.html',
    styleUrls: ['./shipping.component.css']
})
export class ShippingComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmited = false;
    private countDefaultValue = 0;

    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    private createForm() {
        this._form = this.fb.group({
            airShipments: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            airMiles: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            airPounds: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            truckShipments: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            truckMiles: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            truckPounds: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            trainShipments: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            trainMiles: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
            trainPounds: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.digits]],
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmited || this.form.get(param).touched);
    }

    next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'shipping';
        let params = {
            airShipments: this.getFV('airShipments'),
            airMiles: this.getFV('airMiles'),
            airPounds: this.getFV('airPounds'),
            truckShipments: this.getFV('truckShipments'),
            truckMiles: this.getFV('truckMiles'),
            truckPounds: this.getFV('truckPounds'),
            trainShipments: this.getFV('trainShipments'),
            trainMiles: this.getFV('trainMiles'),
            trainPounds: this.getFV('trainPounds')
        };

        if ((!!+params.airShipments && !!+params.airMiles && !!+params.airPounds) ||
            (!!+params.truckShipments && !!+params.truckMiles && !!+params.truckPounds) ||
            (!!+params.trainShipments && !!+params.trainMiles && !!+params.trainPounds)) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];
                    this.emissionService.setEmission({
                        category: Constants.categories.business.shipping,
                        emission: {
                            emission: input.emmission,
                            emissionTrees: input.emissionTrees,
                            DollarAmt: input.DollarAmt,
                            DollarAmtMonthly: input.DollarAmtMonthly
                        }
                    });

                    this.footerService.skip();
                    this.spinner.hide();
                }
            );
        } else {
            this.emissionService.setEmission({
                category: Constants.categories.business.shipping,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });

            this.footerService.skip();
        }
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/shipping/shipping.component.ts